import { Modal, ModalContent } from "semantic-ui-react"
import React, { useEffect, useState } from "react"
import { AddVehicle, AddDriver, ConfirmVehicle } from "caradvise_shared_components"
import store from "../../actions/configureStore"
import { FAILURE, NOTIFICATION_TYPE, SUCCESS } from "../../constants/notification"
import CustomNotification from "./CustomNotification"

const AddVehicleModal = ({ card, setCard, loadUnenrolledVehicles = false }) => {
  const [openDriverModal, setOpenDriverModal] = useState(false)
  const [error, setError] = useState({})
  const [vehicle, setVehicle] = useState(null)
  const [driver, setDriver] = useState(null)
  const [drivers, setDrivers] = useState([])
  const [loading, setLoading] = useState(false)

  const getVehicle = async (rawData) => {
    setLoading(true)
    if (rawData.license) {
      store.dispatch({
        type: "LICENSE_PLATE_TO_VIN",
        payload: {
          license: rawData.license,
          selectedState: rawData.selectedState
        },
        callback: (status, data) => {
          if (status === "success") {
            rawData.vin = data.vin
            searchVehicleByVin(rawData)
          } else if (status === "failure") {
            setError({ license: true })
            setLoading(false)
            CustomNotification(NOTIFICATION_TYPE.DANGER, "Error", data.error)
          }
        }
      })
    } else {
      searchVehicleByVin(rawData)
    }
  }

  const searchVehicleByVin = (rawData) => {
    store.dispatch({
      type: "SEARCH_VEHICLE_BY_VIN",
      payload: {
        vin: rawData.vin,
        cache: false
      },
      callback: (status, data) => {
        if (status === SUCCESS) {
          if (data?.vehicle) {
            setError({ vin: true })
            setLoading(false)
            return
          }

          if (!data?.vehicle_lookup) return

          if (rawData.license) {
            data.vehicle_lookup.vin = rawData.vin
          }

          setVehicle(data?.vehicle_lookup)

          setLoading(false)
        }

        if (status === FAILURE) {
          CustomNotification(NOTIFICATION_TYPE.DANGER, "Error", data?.error)
        }
      }
    })
  }

  const getDrivers = () => {
    store.dispatch({
      type: "LOAD_DRIVERS",
      callback: (_, drivers) => {
        const driverList =
          drivers.map((driver) => {
            return {
              key: driver?.id,
              value: driver?.id,
              text: driver?.name
            }
          }) || []
        setDrivers(driverList)
      }
    })
  }

  useEffect(() => {
    getDrivers()
  }, [])

  const submitDriver = (data) => {
    setLoading(true)
    data.roles = ["Driver"]
    store.dispatch({
      type: "USER_CREATE_OR_UPDATE_SAGA",
      payload: {
        formData: data
      },
      callback: (status, response) => {
        setLoading(false)
        if (status === "success") {
          setDriver(response.data)
          setOpenDriverModal(false)
          getDrivers()
        }
      }
    })
  }

  const editVehicles = (data) => {
    setLoading(true)
    store.dispatch({
      type: "VEHICLE_CREATE_OR_UPDATE_SAGA_V6",
      payload: {
        formData: {
          ...data.vehicles,
          id: card.id
        }
      },
      callback: (status) => {
        if (status === "success") {
          store.dispatch({
            type: "UPDATE_FLEETCOR_VEHICLE",
            payload: {
              enroll_code: "enrolled",
              vehicleId: card.id
            },
            callback: (status) => {
              setLoading(false)
              if (status === "success") {
                if (loadUnenrolledVehicles) {
                  store.dispatch({
                    type: "LOAD_UN_ENROLL_VEHICLES"
                  })
                }
                setVehicle(null)
                setCard(null)
                CustomNotification(
                  NOTIFICATION_TYPE.SUCCESS,
                  "Success",
                  "Card assigned successfully"
                )
                store.dispatch({
                  type: "VEHICLES_LOAD_SAGA"
                })
              } else {
                CustomNotification(NOTIFICATION_TYPE.DANGER, "Error", "Failed to enroll vehicle!")
              }
            }
          })
        } else {
          setLoading(false)
        }
      }
    })
  }

  const closeModal = () => {
    setCard(null)
    setVehicle(null)
  }

  return (
    <>
      <Modal
        open={card}
        closeOnEscape={true}
        closeOnDimmerClick={true}
        onClose={() => {
          closeModal()
        }}
        size={"tiny"}
      >
        <ModalContent>
          {card && (
            <AddVehicle
              showAddDriver={() => setOpenDriverModal(true)}
              getVehicle={getVehicle}
              error={error}
              vehicle={vehicle}
              setVehicle={setVehicle}
              drivers={drivers}
              confirmVehicle={editVehicles}
              driver={driver}
              card={card}
              loading={loading}
              closeModal={closeModal}
            />
          )}
        </ModalContent>
      </Modal>
      <Modal open={openDriverModal} size={"tiny"} onClose={() => setOpenDriverModal(false)}>
        <ModalContent>
          <AddDriver
            closeModal={() => setOpenDriverModal(false)}
            addDriver={submitDriver}
            loading={loading}
          />
        </ModalContent>
      </Modal>
    </>
  )
}

export default AddVehicleModal
